import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current member may see the Live Trading V2 surfaces (D-020):
 * derivative spread/total one-click, two-sided ladders, A/D hotkeys, and the
 * multi-line view. The relay resolves this from traderRules.lt2Enabled
 * (fail-closed). The relay independently requires this capability on every
 * LT2-tagged order in addition to ordinary one-click entitlement, so flipping
 * it off is a per-trader V2 kill switch without revoking V1 one-click.
 */
export function useLt2Access(): boolean {
  return useAuthStore((s) => s.user?.lt2Access ?? false);
}
